import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { apiErrorMessage } from '../core/api-error';
import { API_CLIENT_CONFIG } from '../core/api-client-config';
import { CrmSettings, UpdateCrmSettingsRequest } from '../models';

/** The CRM-wide settings: the Crm role reads them, only Admin changes them. */
@Injectable({ providedIn: 'root' })
export class AdminCrmSettingsApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = `${inject(API_CLIENT_CONFIG).crmApiBaseUrl}/api/admin/BackofficeCrmSettings`;

  getSettings() {
    return this.httpClient.get<CrmSettings>(`${this.baseUrl}`);
  }

  updateSettings(dto: UpdateCrmSettingsRequest) {
    return this.httpClient.put<void>(`${this.baseUrl}`, dto).pipe(
      catchError((error) =>
        throwError(() =>
          apiErrorMessage(error, {
            Forbid:
              'Solo un amministratore può cambiare le impostazioni del CRM.',
          }),
        ),
      ),
    );
  }
}
